import styled from 'styled-components';

/* Mixins */
import { FlexCenterChildren, FlexSpaceBetween } from 'styles/Mixins';

export const MOBILE_HEADER_HEIGHT = 58;
export const DESKTOP_HEADER_HEIGHT = 80;

export const Container = styled.div<{ shouldRenderMobile: boolean }>`
  width: calc(
    100% - ${({ shouldRenderMobile }) => (shouldRenderMobile ? 32 : 225)}px
  );
  ${FlexSpaceBetween}
  align-items: center;
`;

export const Header = styled.div<{
  shouldRenderMobile: boolean;
  isFixed?: boolean;
}>`
  min-height: ${({ shouldRenderMobile }) =>
    shouldRenderMobile ? MOBILE_HEADER_HEIGHT : DESKTOP_HEADER_HEIGHT}px;
  ${FlexCenterChildren};
  width: 100%;
  border-bottom: 0.5px solid ${({ theme }) => theme.borderBrandGuidelinesGrey};
  background-color: ${({ theme }) => theme.white};
  z-index: ${({ theme }) => theme.zIndexBase1};

  ${({ isFixed }) =>
    isFixed &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  `};
`;
